import { Component, OnInit } from '@angular/core';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseFlowComponent } from '../purchase-flow/purchase-flow.component';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.css']
})
export class ShoppingCartComponent implements OnInit {

  faShoppingCart = faShoppingCart;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  openCart(): void {
      const modalRef = this.modalService.open(PurchaseFlowComponent, { size: 'lg', backdrop: 'static' });
      modalRef.componentInstance.purchaseStage = 'Cart';
  }
}
